import { useMemo } from 'react'
import { ScheduleType } from 'types/schedule'
import { UseStoreDeliveryBread } from 'hooks/storeDeliveryBread/useStoreDeliveryBread'
import { isValidSchedules, isValidStoreDeliveryBread } from 'lib/validator'

const useFilledRequiredForm = (values: {
  name: string
  imageUrls: string[]
  description: string
  categoryId: string
  price: number
  status: string
  isScheduledGeneration: boolean
  isTypeDaily: boolean
  dailySchedules: ScheduleType[]
  isTypePreorder: boolean
  preorderSchedules: ScheduleType[]
  isTypeDelivery: boolean
  storeDeliveryBreadForm: UseStoreDeliveryBread
}): boolean => {
  const {
    name,
    imageUrls,
    description,
    categoryId,
    price,
    status,
    isScheduledGeneration,
    isTypeDaily,
    dailySchedules,
    isTypePreorder,
    preorderSchedules,
    isTypeDelivery,
    storeDeliveryBreadForm,
  } = values

  const isValidDailyType = !isTypeDaily || (isTypeDaily && isValidSchedules(dailySchedules, isScheduledGeneration))
  const isValidPreorderType = !isTypePreorder || (isTypePreorder && isValidSchedules(preorderSchedules, true))
  const isValidDeliveryType = !isTypeDelivery || (isTypeDelivery && isValidStoreDeliveryBread(storeDeliveryBreadForm))

  return useMemo(() => {
    return (
      name !== '' &&
      imageUrls.length > 0 &&
      description !== '' &&
      categoryId !== '' &&
      price !== 0 &&
      status !== '' &&
      isValidDailyType &&
      isValidPreorderType &&
      isValidDeliveryType
    )
  }, [
    name,
    imageUrls,
    description,
    categoryId,
    price,
    status,
    isScheduledGeneration,
    isValidDailyType,
    isValidPreorderType,
    isValidDeliveryType,
  ])
}

export default useFilledRequiredForm
